import React from "react";
import { Link } from "react-router-dom";

import { ResearchCard, Title } from "..";

import { researchs } from "../../assets/data/data";
// import ResearchCard from "../researchCard/researchCard";

const Research = () => {
  return (
    <section className="research">
      <div className="container">
        <Title
          title="Tadqiqot loyihalari"
          subtitle="Sizga mos bo'lgan tadqiqot loyihasini toping"
        />
        <div className="row gx-4 gy-5">
          {researchs.slice(0, 4).map((item) => (
            <ResearchCard {...item} key={item.id} />
          ))}
        </div>
        <div className="row">
          <div className="col-12 text-center mt-5">
            <Link to="/research" className="theme-btn">
              Barcha tadqiqot loyihalarini ko'rish
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Research;
